export { BankDetailsModal } from "./BankDetailsModal";
